import React from 'react';
import { OnBlur, OnChange, OnFocus } from 'react-final-form-listeners';
var FFFieldListnerWrapper = function (_a) {
    var name = _a.name, children = _a.children, onFieldBlur = _a.onFieldBlur, onFieldChange = _a.onFieldChange, onFieldFoucus = _a.onFieldFoucus;
    return (React.createElement(React.Fragment, null,
        children,
        onFieldChange && React.createElement(OnChange, { name: name }, onFieldChange),
        onFieldBlur && React.createElement(OnBlur, { name: name }, onFieldBlur),
        onFieldFoucus && React.createElement(OnFocus, { name: name }, onFieldFoucus)));
};
export default FFFieldListnerWrapper;
//# sourceMappingURL=FFFieldListnerWrapper.js.map